import { render, staticRenderFns } from "./ProductImgUpload.vue?vue&type=template&id=b6dbf710&scoped=true&"
import script from "./ProductImgUpload.vue?vue&type=script&lang=js&"
export * from "./ProductImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProductImgUpload.vue?vue&type=style&index=0&id=b6dbf710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dbf710",
  null
  
)

export default component.exports